export const en = {
  title: "Profile",
  pageTitle: "Profile Settings",
  pageSubtitle: "Manage your personal information and preferences",
  cardTitle: "Personal Information",
  cardDescription: "Your account details",
  saveChanges: "Save Changes",
  fields: {
    name: {
      label: "Name",
      helper: "Your display name across the application",
      errorRange: "Name must be between 1 and 100 characters",
      errorRequired: "Name is required",
      errorMaxLength: "Name must be 100 characters or fewer",
    },
    email: {
      label: "Email Address",
      helper: "Used for sign-in and notifications",
    },
    role: {
      label: "Role",
      helper: "Assigned by your workspace administrator",
    },
    team: {
      label: "Team",
      helper: "Assigned by your workspace administrator",
      noTeam: "No team",
    },
  },
  adminManagedNotice: "Email address, role, and team assignments are managed by your workspace administrator. Contact them to request changes.",
  errorLoadFailed: "Failed to load profile information.",
  toastUpdated: "Profile updated",
  toastUpdateFailed: "Failed to update profile",
  saved: "Profile updated.",
  saveFailed: "Failed to update profile.",
} as const;
